<template>
  <div v-if="tabList.length">
    <md-popup
      class="w-fullVw bg-F2F2F6 evaluate-popup"
      v-model="popProps.open"
      :open="popProps.open"
      :maskClosable="popProps.maskClosable"
      :zIndex="popProps.zIndex"
      :position="popProps.position"
    >
      <div class="h-44 bg-FFFFFF p-0-16 fb fb-cross-center fb-main-between">
        <i
          class="iconfont font-14 text-bold-600 c-171A1D-60"
          @click="popProps.open = false"
          >&#xe63b;</i
        >
        <span class="font-36">{{ title }}</span>
        <span
          v-show="showRight"
          class="font-28 c-006AFE"
          @click="emitRightClick"
          >图文点评</span
        >
        <span v-show="!showRight" class="font-28 c-006AFE"> </span>
      </div>
      <div
        class="tab-wrap mt-12 p-0-8 bg-FFFFFF bb-8 text-center lh-48 h-48 nowrap bb fb fb-cross-center scroll-x"
        :class="[tabList.length <= 3 ? 'fb-main-center' : 'fb-main-between']"
      >
        <div
          v-for="(item, index) in tabList"
          :key="`tab${index}`"
          @click="handlerChangeState(item, index)"
          class="font-30 ff-regular relative item-shrink-0"
          :class="[
            item.moralEduEvaluationGroupId === curMoralEduEvaluationGroupId
              ? 'c-006AFE'
              : 'c-171A1D-56',
            tabList.length <= 3 ? 'p-0-8 item-flex-1' : 'pl-8 pr-16'
          ]"
        >
          {{ item.moralEduEvaluationGroupName }}
          <div
            v-show="
              item.moralEduEvaluationGroupId === curMoralEduEvaluationGroupId
            "
            class="tab-bottom"
          >
          </div>
        </div>
      </div>
      <div>
        <div
          v-show="curMoralEduEvaluationGroupId !== WORD_COMMENT_ID"
          v-for="(result, index) in resultList"
          :key="'evaluate' + index"
        >
          <div
            class="fb fb-row bg-FFFFFF p-0-12 p-12-0 fb-wrap hidden"
            v-show="
              result.moralEduEvaluationGroupId ===
                curMoralEduEvaluationGroupId && curGroupListLen
            "
          >
            <template v-for="(item, index) in result.evaluationItems">
              <div
                :key="`evaluation${index}`"
                @click="handlerClickEvaluation(item)"
                class="text-center badge-list"
                :class="{
                  active:
                    moralEduEvaluationItemId === item.moralEduEvaluationItemId
                }"
              >
                <div class="badge-icon">
                  <img
                    v-if="item.evaluationItemPic"
                    :src="item.evaluationItemPic"
                    key="img"
                  />
                  <div
                    v-else
                    class="default-icon font-30 fb fb-cross-center fb-main-center ff-medium c-FFFFFF"
                    key="default-icon"
                    v-html="formatGroupItemName(item)"
                  >
                  </div>
                </div>
                <p class="font-24 c-171A1D-60 ff-regular">
                  {{ item.evaluationItemName }}
                </p>
                <p
                  class="font-24 c-171A1D-60 ff-regular"
                  :class="{
                    'c-FF9200': item.evaluationItemScore < 0
                  }"
                >
                  {{ item.evaluationItemScore > 0 ? `+` : ''
                  }}{{ item.evaluationItemScore }}分
                </p>
              </div>
            </template>
          </div>
          <slot
            name="empty"
            v-bind:info="{
              empty:
                result.moralEduEvaluationGroupId ===
                  curMoralEduEvaluationGroupId && !curGroupListLen
            }"
          ></slot>
        </div>

        <div v-show="curMoralEduEvaluationGroupId === WORD_COMMENT_ID">
          <div class="bg-FFFFFF p-0-16 p-12-0 h-200">
            <textarea
              :placeholder="isSaying === 0 ? '请输入文字点评' : '说出点评内容'"
              class="font-34 h-160"
              cols="30"
              rows="7"
              maxlength="45"
              v-model="wordComment"
            ></textarea>
            <div class="c-191F25-56 fb fb-main-end">
              <span>{{ wordComment.length }}/45</span>
            </div>
          </div>
          <div class="relative" v-if="IS_DING">
            <div
              class="m-0-auto mt-20 fb fb-cross-center fb-main-center saying transform-ease"
              :class="{ transparent: isSaying !== 2 }"
            >
              <div
                class="fb fb-cross-center fb-main-center relative transform-ease"
                :class="{
                  transparent: isSaying !== 1,
                  'start-saying': isSaying
                }"
              >
                <span
                  v-show="isSaying === 3"
                  class="icon-saying absolute rotate"
                ></span>
                <span
                  v-show="isSaying === 4"
                  class="icon-said absolute rotate"
                ></span>
                <div
                  @touchstart="handlerTouchstart"
                  @touchmove="handlerTouchmove"
                  @touchend="handlerTouchend"
                  class="fb fb-cross-center fb-main-center volum-icon"
                  :class="{ 'bg-94DFB7': isSaying === 4 }"
                >
                  <span class="iconfont font-44">{{
                    isSaying === 4 ? '&#xe690;' : '&#xe6b3;'
                  }}</span>
                </div>
              </div>
            </div>
            <p
              v-show="!isSaying"
              class="font-24 c-171A1D-56 mt-4 absolute width-full text-center volumn-text"
              >长按说话</p
            >
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import {
  dingAudioStartRecord,
  dingAudioEnd,
  dingAudioTranslateVoice,
  dingAudioStopRecord
} from '@/utils/mcSdkUtils'
import { IS_DING, filterName } from '@/utils/comUtils'
const WORD_COMMENT_ID = '3'
export default {
  name: 'evaluationType',

  props: {
    single: {
      type: Boolean,
      default: false
    },
    resultList: {
      type: Array,
      default: () => []
    },
    showRight: {
      type: Boolean,
      default: true
    },
    popProps: {
      type: Object,
      default: () => {
        return {
          open: true,
          maskClosable: false,
          zIndex: 9999,
          position: 'bottom'
        }
      }
    },
    selectedStudentList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      IS_DING,
      tabIndex: 0,
      WORD_COMMENT_ID,
      isSaying: 0, // 0: 默认 1: 短按 2: 长按 3: 识别中 4: 识别完成
      timeOutEvent: null,
      startX: 0,
      endX: 0,
      startY: 0,
      endY: 0,
      evaluationType: 1,
      wordComment: '', // 输入的文字点评
      moralEduEvaluationItemId: '', // 选中的其他点评
      moralItem: {}
    }
  },
  computed: {
    title() {
      const { selectedStudentList } = this
      let title = ''
      if (selectedStudentList.length === 1) {
        title = `考评 ${filterName(
          selectedStudentList[0].studentName || '',
          6
        )}`
      } else if (selectedStudentList.length > 1) {
        title = `点评 ${selectedStudentList.length}位学生`
      }
      return title
    },
    curMoralEduEvaluationGroupId() {
      if (this.tabList.length) {
        return (this.tabList[this.tabIndex] || {}).moralEduEvaluationGroupId
      }
      return ''
    },
    tabList() {
      // 清空数据
      this.resetData()
      let _tabList = []

      if (!(this.resultList && this.resultList.length)) {
        return _tabList
      }

      _tabList = this.resultList.map(item => {
        return {
          moralEduEvaluationGroupName: item.moralEduEvaluationGroupName,
          moralEduEvaluationGroupId: item.moralEduEvaluationGroupId
        }
      })
      return _tabList
    },
    curGroupListLen() {
      if (!(this.resultList && this.resultList.length)) {
        return 0
      }
      let _curMoralGroupMap = this.resultList[this.tabIndex] || {}
      return (
        _curMoralGroupMap.evaluationItems &&
        _curMoralGroupMap.evaluationItems.length
      )
    }
  },
  watch: {
    'popProps.open'(v) {
      if (!v) {
        this.$emit('close')
      }
    },
    wordComment(newValue) {
      this.emitEvaluation({
        value: newValue,
        volumflag: true
      })
    },
    moralEduEvaluationItemId(newValue) {
      this.emitEvaluation({
        value: newValue,
        volumflag: false
      })
    }
    // curMoralEduEvaluationGroupId(newValue) {
    //   this.emitEvaluation({
    //     value: '',
    //     volumflag: newValue === WORD_COMMENT_ID
    //   })
    // }
  },
  methods: {
    // 单项名称无图时默认展示前4字
    formatGroupItemName({ evaluationItemName } = {}) {
      if (!evaluationItemName) {
        return ''
      }
      return `<div><p>${evaluationItemName.slice(
        0,
        2
      )}</p><p>${evaluationItemName.slice(2, 4)}</p></div>`
    },
    resetData() {
      this.tabIndex = 0
      this.isSaying = 0
      this.timeOutEvent = null
      this.startX = 0
      this.endX = 0
      this.startY = 0
      this.endY = 0
      this.wordComment = ''
      this.evaluationType = 1
      this.moralEduEvaluationItemId = ''
    },

    handlerChangeState(item, index) {
      this.tabIndex = index
    },
    handlerClickEvaluation(item) {
      this.moralItem = item
      this.moralEduEvaluationItemId = item.moralEduEvaluationItemId
      this.evaluationType = item.moralEduEvaluationType
    },
    emitEvaluation({ value, volumflag }) {
      this.$emit('change', {
        moralItem: this.moralItem,
        type: this.curMoralEduEvaluationGroupId, // 选中的分类
        value, // 文字或者是选中的 ID
        volumflag, // 是否为文字标识
        evaluationType: volumflag
          ? Number(WORD_COMMENT_ID)
          : this.evaluationType
      })
    },
    emitRightClick() {
      this.$emit('right-click')
    },
    // 开始录音
    startVolum() {
      // 超时停止录音
      dingAudioEnd()
        .then(res => {
          this.transVolumn(res.mediaId, res.duration)
        })
        .catch(e => {
          this.isSaying = 0
          console.log('e', e)
        })
      dingAudioStartRecord()
    },
    // 语音转文字
    transVolumn(mediaId, duration) {
      dingAudioTranslateVoice(mediaId, duration)
        .then(audio => {
          this.isSaying = 4
          this.wordComment = (audio.content || '').slice(0, 45)
          setTimeout(() => {
            this.isSaying = 0
          }, 1000)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 长按开始
    handlerTouchstart(e) {
      this.isSaying = 1
      let _touch = (e || window.event).targetTouches[0]
      this.startX = _touch.clientX
      this.startY = _touch.clientY
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = setTimeout(() => {
        this.isSaying = 2
        this.startVolum()
      }, 600)
    },
    // 长按结束
    handlerTouchend() {
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = null
      this.isSaying = 3
      dingAudioStopRecord()
        .then(res => {
          this.transVolumn(res.mediaId, res.duration)
        })
        .catch(e => {
          console.log('e', e)
        })
    },
    // 取消长按
    handlerTouchmove(e) {
      let _touch = (e || window.event).targetTouches[0]
      this.endX = _touch.clientX
      this.endY = _touch.clientY
      if (this.endX - this.startX > 10 || this.endY - this.startY > 10) {
        this.isSaying = 0
        clearTimeout(this.timeOutEvent)
        this.timeOutEvent = null
        dingAudioStopRecord()
          .then(res => {
            this.transVolumn(res.mediaId, res.duration)
          })
          .catch(e => {
            this.isSaying = 0
            console.log('e', e)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.common-no-data) {
  z-index: -1;
}
.evaluate-popup {
  height: 560px;
}
.bg-F2F2F6 {
  background: #f2f2f6 !important;
}
.tab-wrap {
  position: relative;
  z-index: 999;
}
.tab-wrap::-webkit-scrollbar {
  display: none;
}
.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 1.5px;
}

.badge-list {
  width: 32%;
  padding: 14px 10px;
  margin-right: 1%;
  border: 2px solid #ffffff;
  border-radius: 8px;
  .badge-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 8px;
    img,
    .default-icon {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: rgba(0, 176, 66, 0.48);
    }
  }
  &:nth-of-type(3n) {
    margin-right: 0;
  }
  &.active {
    border: 2px solid #006afe;
    background: rgba(0, 106, 254, 0.12);
  }
}

.evaluation-lists {
  margin: 0 calc((100% - 320px) / 8) 8px;
}
.evaluation-list {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 auto 8px auto;
}
.evaluation-border {
  border: 1px solid rgba(17, 31, 44, 0.12);
}
.transform-ease {
  transition: all 0.3 ease;
}
.volum-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin: 0 auto;
  color: #006afe;
  background: #ffffff;
  box-shadow: 0px 2px 15px -3px rgba(15, 18, 61, 0.15);
}
.start-saying {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(0, 137, 255, 0.2);
  .volum-icon {
    background: #006afe;
    color: #ffffff;
    &.bg-94DFB7 {
      background-color: #94dfb7;
    }
  }
}
.saying {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(0, 137, 255, 0.2);
}

.transparent {
  background: transparent;
}
.volumn-text {
  bottom: -4px;
}
.icon-saying {
  display: inline-block;
  width: 56px;
  height: 56px;
  background: url(./../assets/images/icon-saying.png) no-repeat center center;
  background-size: 100% 100%;
  z-index: 1;
}
.icon-said {
  display: inline-block;
  width: 56px;
  height: 56px;
  background: url(./../assets/images/icon-said.png) no-repeat center center;
  background-size: 100% 100%;
  z-index: 1;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.rotate {
  animation: rotate 1s 0s linear infinite;
  -webkit-animation: rotate 1s 0s linear infinite;
}
</style>
